import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from 'use-toast-mui';
import { InputAdornment, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CommonModalButton from '../../form-components/CommonModalButton';
import { switchAccount } from '../../api/adminSwitch';
import { errorMessages } from '../../utils/methods';
import {
  SwitchModal,
  PasswordModalContainer,
  ModalHeader,
  ModalTitle,
  CloseButton,
  PasswordModalBody,
  PasswordLabel,
  PasswordInput,
  PasswordModalFooter,
} from './AdminSwitchStyled';

const PasswordInputModal = ({ open, onClose, employee, token, branchId, onSwitchSuccess }) => {
  const { t } = useTranslation();
  const toast = useToast();
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setPassword('');
    setShowPassword(false);
    onClose();
  };

  const handleSubmit = async () => {
    if (!password.trim()) {
      toast.error('비밀번호를 입력해주세요');
      return;
    }
    setLoading(true);
    try {
      const result = await switchAccount(token, employee.userId, password, branchId);
      setPassword('');
      onSwitchSuccess(result, employee);
    } catch (err) {
      toast.error(errorMessages(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <SwitchModal open={open} onClose={handleClose}>
      <PasswordModalContainer>
        <ModalHeader>
          <ModalTitle>{employee?.name || ''} 로그인</ModalTitle>
          <CloseButton onClick={handleClose}>
            <CloseIcon />
          </CloseButton>
        </ModalHeader>
        <PasswordModalBody>
          <PasswordLabel>비밀번호</PasswordLabel>
          <PasswordInput
            type={showPassword ? 'text' : 'password'}
            size="small"
            placeholder="비밀번호를 입력해주세요"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') handleSubmit();
            }}
            autoFocus
            autoComplete="new-password"
            InputProps={{
              autoComplete: 'new-password',
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" size="small">
                    {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </PasswordModalBody>
        <PasswordModalFooter>
          <CommonModalButton variant="cancel" onClick={handleClose}>
            {t('취소')}
          </CommonModalButton>
          <CommonModalButton variant="submit" onClick={handleSubmit} disabled={loading}>
            {loading ? '로그인 중...' : '확인'}
          </CommonModalButton>
        </PasswordModalFooter>
      </PasswordModalContainer>
    </SwitchModal>
  );
};

export default PasswordInputModal;
